import { LOCALE_ID, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LoanLayoutModule } from "./loan-layout/loan-layout.module";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { registerLocaleData } from "@angular/common";
import localeEnIn from "@angular/common/locales/en-IN";
import { AuthInterceptor } from "./shared/interceptors/auth.interceptor";
import { ToastrModule } from "ngx-toastr";
import { MatDialogModule } from "@angular/material/dialog";
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { IMqttServiceOptions, MqttModule } from "ngx-mqtt";
import { environment } from "src/environments/environment";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { AngularFireModule } from "@angular/fire/compat";
import { SharedModule } from "./shared/shared.module";
import { LottieModule } from "ngx-lottie";
import { SplashScreenComponent } from "./shared/components/splash-screen/splash-screen.component";

export function playerFactory(): any {
    return import("lottie-web");
}

export function mqttServiceOptions(): IMqttServiceOptions {
    return {
        connectOnCreate: false,
    };
}

registerLocaleData(localeEnIn, "en-IN");

@NgModule({
    declarations: [AppComponent, LoaderComponent, SplashScreenComponent],
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        LoanLayoutModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: "toast-top-center",
        }),
        MatDialogModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireMessagingModule,
        MqttModule.forRoot(mqttServiceOptions()),
        LottieModule.forRoot({ player: playerFactory }),
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: "en-IN",
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
